import { useLocation, useNavigate } from 'react-router-dom'

// Router state an incidents list hands to the incident screens, so their back
// arrows can return to the list with its filters still applied.
export type IncidentListReturnState = { listSearch?: string }

export const useIncidentListReturn = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const returnState = location.state as IncidentListReturnState | null

  const navigateWithinIncident = (to: string) =>
    navigate(to, { relative: 'path', state: returnState })

  const navigateToList = (to: string) =>
    navigate(
      { pathname: to, search: returnState?.listSearch ?? '' },
      { relative: 'path' }
    )

  return { returnState, navigateWithinIncident, navigateToList }
}
